import React from 'react'
import { Paula } from '@labcon/copesa-logos'

const Footer = () => {
  return (
    <div className="w-full bg-rojo sm:h-20 h-14">
      <div className="container grid items-center justify-center sm:grid-cols-12 p-4 mx-auto sm:h-20 h-14 ">
        <div className="col-span-8">
          <p className="p-0 text-sm leading-none">
            &copy; {new Date().getFullYear()} Paula, de La Tercera. Todos los
            derechos reservados.
          </p>
        </div>
        <div className="flex justify-end col-span-4 text-right">
          <h2>
            <a
              href="https://www.latercera.com/canal/paula/?utm_source=copihue"
              target="_blank"
              rel="noopener noreferrer">
              <Paula className="h-8" schema="light" />
            </a>
          </h2>
        </div>
      </div>
    </div>
  )
}

export default Footer
